export default __webpack_public_path__ + "static/media/poo.ea3f2972.gif";